// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './vuex/store' // 引入store
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import bus from './assets/utils/eventBus.js';
Vue.use(VueAwesomeSwiper)　
import axios from 'axios'
import common from './assets/utils/common'
Vue.prototype.$common = common
axios.interceptors.response.use(
  function (response) {
    if(response.data.code==1){
      return response
    }
    if(response.data.code==0){
      alert(response.data.msg)
    }
    if(response.data.code==201){
      window.sessionStorage.token = '';

      axios.defaults.headers.common["Authorization"] = ''

      bus.$emit('login');
    }
    // 对响应数据进行处理

  },
  function (error) {
    // 对响应错误进行处理
    return Promise.reject(error);
  }
);
Vue.prototype.$axios = axios
router.beforeEach((to, from, next) => {
 if (to.meta.title) {
     document.title = to.meta.title;
   }
// chrome

document.body.scrollTop = 0

// firefox

document.documentElement.scrollTop = 0

// safari

window.pageYOffset = 0

next()

})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js